module.exports = __webpack_public_path__ + "img/PhotoExhibit-Estonia.5c02c176.jpg";